import { render } from "./menu.vue?vue&type=template&id=65c50470&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=65c50470&lang=scss&scoped=true"

import exportComponent from "E:\\Work\\TEHNOLAND\\megamarketAdmin\\adm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c50470"]])

export default __exports__